import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  itemHeader: {
    fontWeight: 'bold',
    textAlign: 'justify',
    fontSize: 20,
    marginTop: 15,
    marginBottom: 3,
  },
  textHeader: {
    textAlign: 'justify',
    fontSize: 15,
    marginTop: 0,
  },
  textMarginTop10: {
    textAlign: 'justify',
    fontSize: 15,
    marginTop: 10,
  },
}));
